"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nContainer = void 0;
var _auth = require("@ori/auth");
var _commonFormFields = require("@ori/common-form-fields");
var _i18n = require("@ori/i18n");
var _defaultTranslations = require("../constants/defaultTranslations");
var _jsxRuntime = require("react/jsx-runtime");
const I18nContainer = props => {
  const {
    currentLanguage,
    staticApiUrl,
    tenant,
    children
  } = props;
  const {
    token
  } = (0, _auth.useToken)();
  const translationProps = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: error => {
        console.log('Error occured while loading translations.', String(error));
      },
      tenant,
      token
    },
    currentLanguage,
    defaultTranslationsWithNamespaces: {
      [_defaultTranslations.translationsNamespace]: _defaultTranslations.defaultTranslations,
      [_commonFormFields.translationsNamespace]: _commonFormFields.defaultTranslations
    }
  };
  if (!(0, _auth.isTokenValid)(token)) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
    ...translationProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _defaultTranslations.translationsNamespace,
      children: children
    })
  });
};
exports.I18nContainer = I18nContainer;
//# sourceMappingURL=I18nContainer.js.map